









import { Vue, Component } from 'vue-property-decorator';

import YourAccountEmail from '../default-user-signup/YourAccount.vue';
import { OnboardingURL } from '@/views/Onboarding/helpers';

@Component({
  components: { YourAccountEmail }
})
export default class AIYourAccountEmail extends Vue {
  get backUrl() {
    return OnboardingURL.AI_CAMPAIGNS;
  }

  get redirectUrl() {
    return OnboardingURL.AI_CREATE_CAMPAIGNS;
  }

  get nextUrl() {
    return OnboardingURL.AI_USER_SIGN_UP_COMPLETE;
  }
}
